<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminUmbTypeForm from '@/components/admin/umbType/AdminUmbTypeForm.vue'
import { AloDbUmbType } from '@/models/alodb/AloDbUmbType'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminUmbType',
  components: {AdminUmbTypeForm}
})
export default class AdminUmbType extends AdminForm<AloDbUmbType> {  
  
  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT_TYPE].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }

  get itemTypeName() {
    return "UmbType"
  }

  get originalLibelle() {
    return this.original.UMT_LIBELLE
  }

}
</script>